const moment = require('moment')

import { deliveryStore } from '../store/deliveryStore'
import { orderStore } from '../store/orderStore'
import { Repository } from '../services/Repository'

export const dates = {

	data () {
		return {
			deliveryStore: deliveryStore.state
		}
	},
	computed: {
		delivery () {
            var sub = this.user.subscription
            return this.deliveryStore
                && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id)
                && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id).attributes
        },

		$_dates_dateCutOff () {
			if (this.user.order && this.user.order.date) return this.$_dates_readableDate(this.user.order.date.cutoff)
			if (!this.delivery) return
			return (this.delivery.shipment_day === 1 || this.delivery.shipment_day === 2)
				? this.$_dates_thisWeekDay(4)
				: this.$_dates_nextWeekDay(0)
		}
	},

	methods: {
		$_dates_nextWeekDay (day) {
			return moment().day(day + 7).locale('it').format('dddd D MMMM')
		},

		$_dates_thisWeekDay (day) {
			return moment().day(day).locale('it').format('dddd D MMMM')
		},

		$_dates_readableDate (date) {
			return moment(date).locale('it').format('dddd D MMMM')
		},

    $_dates_readableShortDate (date) {
      return moment(date).locale('it').format('ddd, D MMM')
    },

    $_dates_readableDateAndHour (date) {
      return this.$_dates_readableDate(date) + " " + this.$_date_readableDateHour()
    },

    $_date_readableDateHour() {
      let timeRange = new Repository().getCurrentDeliveryTimeRange();
      
      if (timeRange) {
        return timeRange.attributes.start.slice(0, -3) + " - " + timeRange.attributes.end.slice(0, -3)
      } else {
        return '(loading ...)'
      }
    },

		$_dates_readableDay (date) {
			return moment(date).locale('it').format('D')
		},

		$_dates_readableDayMonth (date) {
			return moment(date).locale('it').format('D MMMM')
		},

		$_dates_readableMonth (date) {
			return moment(date).locale('it').format('MMMM')
		},

		$_dates_readableWeekDay (num) {
			switch (num) {
			case 0:
				return 'domenica'
			case 1:
				return 'lunedì'
			case 2:
				return 'martedì'
			case 3:
				return 'mercoledì'
			case 4:
				return 'giovedì'
			case 5:
				return 'venerdì'
			case 6:
				return 'sabato'
			}
		},

		$_dates_loadDelivery () {
			if (!this.user) return
			if (this.user.order && this.user.order.date) return

			if (!this.user.order) return

        	return deliveryStore.getDelivery({ 
	        	target_type: 'order', 
	        	target_id: this.user.order.id
	    	})
        }
	}
}
